import { render, staticRenderFns } from "./register-review-new.vue?vue&type=template&id=a4bd9aee&lang=pug&"
import script from "./register-review-new.vue?vue&type=script&lang=ts&"
export * from "./register-review-new.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports